import { FC } from 'react';
import { CookiebotCategory, useCookiebotCategoryConsent } from './consent';

type OpenConsentModalRenderer = ({
  openConsentModal,
}: {
  openConsentModal: () => void;
}) => React.ReactNode;

type RenderFunction = () => React.ReactNode;

interface Props {
  category: CookiebotCategory;
  render: RenderFunction;
  renderFallback?: OpenConsentModalRenderer;
}

const ConsentGuard: FC<Props> = ({ render, category, renderFallback }) => {
  const hasConsent = useCookiebotCategoryConsent(category);

  if (!hasConsent && renderFallback) {
    const openConsentModal = () => window.Cookiebot?.renew();
    return renderFallback({ openConsentModal });
  }

  if (!hasConsent) {
    return null;
  }

  return render();
};

export default ConsentGuard;
